import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AvatarS from './avatar';
import { chatInfoForm } from '../services/chatBotService';

// Utility to convert URLs in text to clickable links
function linkify(text) {
  if (!text) return '';
  const urlRegex =
    /(https?:\/\/[\w\-._~:/?#[\]@!$&'()*+,;=%]+)|(www\.[\w\-._~:/?#[\]@!$&'()*+,;=%]+)/gi;
  return text.replace(urlRegex, (url) => {
    const href = url.startsWith('http') ? url : `https://${url}`;
    return `<a href="${href}" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
}

// Utility to split text into bullet points at periods
function bulletify(text) {
  if (!text) return [];
  // Split at period followed by space or end of string, but keep the period
  return text
    .split(/\.(?=\s|$)/)
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => s + '.');
}

/* eslint-disable import/order */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable arrow-spacing */
/* eslint-disable space-in-parens */
/* eslint-disable operator-linebreak */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable indent */
/* eslint-disable jsx-quotes */
/* eslint-disable react/jsx-indent */
/* eslint-disable camelcase */

function ChatText({
  text,
  user = 0,
  chatFormDisplay,
  setDialogFlow,
  index,
  messageCount,
  avatar,
  displayViewSummaryButton,
  openSummaryForm,
  leaseholder,
  undoChatResponse = (value) => {},
}) {
  const [parsedJson, setParsedJson] = useState({});
  const isJson = typeof text === 'object';

  // Function to check if text should be bulletified (contains periods)
  const shouldBulletify = (textContent) => {
    if (!textContent) return false;
    // Don't bulletify if text starts with "I'm Sarge"
    if (textContent.trim().startsWith("I'm Sarge")) return false;
    // Don't bulletify if text doesn't contain periods
    if (!textContent.includes('.')) return false;

    // Split by periods and check if there are multiple sentences
    const sentences = textContent
      .split(/\.(?=\s|$)/)
      .map((s) => s.trim())
      .filter(Boolean);

    // Only bulletify if there are multiple sentences
    return sentences.length > 1;
  };

  const handleParsedData = (parsedData) => {
    setParsedJson(parsedData);
    const technicianNotes = parsedData.technician_notes;
    if (parsedData.wo_created === 'True') {
      setDialogFlow({ ...parsedData, technician_notes: technicianNotes });
    } else {
      chatInfoForm({ ...parsedData, technician_notes: technicianNotes });
    }
  };

  useEffect(() => {
    try {
      if (isJson) {
        handleParsedData(text);
      } else {
        setParsedJson({});
      }
    } catch (error) {
      setParsedJson({});
    }
  }, []);

  const displayTechnicianNote = (technicianNote) => {
    if (technicianNote && technicianNote.length > 0) {
      return technicianNote.map((item) => <div key={item}>{item}</div>);
    }
    return null;
  };

  // Function to render bulletified text
  const renderBulletifiedText = (textContent) => {
    const bulletPoints = bulletify(textContent);
    return (
      <ul style={{ margin: 0, paddingLeft: '20px' }}>
        {bulletPoints.map((bullet, idx) => (
          <li key={idx} dangerouslySetInnerHTML={{ __html: linkify(bullet) }} />
        ))}
      </ul>
    );
  };

  // Function to render regular text
  const renderRegularText = (textContent) => {
    return <span dangerouslySetInnerHTML={{ __html: linkify(textContent) }} />;
  };

  return (
    <div>
      <div
        className={`chat-text ${user ? 'left' : 'right'}`}
        style={{ marginBottom: '10px' }}
      >
        {avatar}
        <label
          className={
            text === 'Please type a response below...' && 'waiting-message'
          }
          style={{ marginLeft: '5px', marginRight: '5px' }}
        >
          {!isJson
            ? shouldBulletify(text)
              ? renderBulletifiedText(text)
              : renderRegularText(text)
            : Object.keys(parsedJson).map((key) => (
                <pre key={key} className="wrapped-pre">
                  <strong>{key}:</strong>
                  {key === 'technician_notes'
                    ? displayTechnicianNote(parsedJson[key])
                    : parsedJson[key]}
                </pre>
              ))}
        </label>
        {!user && <AvatarS user={user} />}
      </div>
      {displayViewSummaryButton && (
        <div className="chat-text left" style={{ marginBottom: '10px' }}>
          <AvatarS user={1} />
          <label style={{ marginLeft: '5px', marginRight: '5px' }}>
            <span className="view-summary-button" onClick={openSummaryForm}>
              View Summary & Submit Ticket{' '}
            </span>
          </label>
        </div>
      )}
      {/* {!user && (messageCount - 2 === index || messageCount - 3 === index) && (
        <div
          className={`chat-text ${!user ? 'right' : ''}`}
          style={{ cursor: 'pointer' }}
          onClick={() => {
            undoChatResponse('/undo');
          }}
        >
          <u>Undo</u>
        </div>
      )} */}
    </div>
  );
}

ChatText.propTypes = {
  text: PropTypes.string.isRequired,
  user: PropTypes.number.isRequired,
  chatFormDisplay: PropTypes.func.isRequired,
  setDialogFlow: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  avatar: PropTypes.node.isRequired,
  messageCount: PropTypes.number.isRequired,
  undoChatResponse: PropTypes.func.isRequired,
  displayViewSummaryButton: PropTypes.bool.isRequired,
  openSummaryForm: PropTypes.func.isRequired,
  leaseholder: PropTypes.string.isRequired,
};

export default ChatText;
